@import '../../../../../static/less/variables.less';

.pricingFrame_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;

  .divider {
    width: 80%;
    background-color: rgb(191, 189, 189);
    height: 1px;
    margin-bottom: 30px;
    opacity: 0.4;
  }

  .title {
    text-align: center;
    font-size: 36px;
    font-weight: lighter;
  }

  .pricingBox {
    .upperRow {
      margin-top: 50px;
      display: flex;
      flex-direction: row;

      justify-content: center;

      .header {
        font-weight: lighter;
        color: #333;
        font-size: 23px;
      }

      .yearlyText {
        display: flex;
        flex-direction: column;
        align-items: center;

        .smallText {
          color: @pipl-blue;
          font-size: 18px;
          margin-top: 2px;
        }
      }

      .switchWrapper {
        margin-left: 25px;
        margin-right: 25px;
        margin-top: 3px;
        border: @pipl-blue solid 1.5px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 27px;
        width: 52px;
        border-radius: 15px;
      }

      .text {
        font-weight: lighter;
        color: #333;
        font-size: 17px;
      }
    }

    .plansContainer {
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      color: #e2e2e2;

      .planBox {
        box-sizing: content-box;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 15px;
        margin-right: 10px;
        margin-left: 10px;
        border: transparent solid 0.5px;
        // width: 200px;

        .planTitle {
          padding: 15px;
          padding-bottom: 20px;
          display: flex;
          align-items: center;
          color: @pipl-blue;
          font-size: 36px;
          font-weight: 500;
          justify-content: center;
          border-bottom: @pipl-blue solid 0.5px;
        }

        .planBody {
          color: #333;
          text-align: center;
          font-size: 22px;
          font-weight: lighter;
          margin-top: 40px;
        }

        .planCost {
          color: #333;
          font-size: 25px;
          text-align: center;
          font-weight: 500;
          margin-top: 30px;
        }

        .monthlyCost {
          font-size: 18px;
          font-weight: bold;
        }

        .monthlyName {
          // font-weight: lighter;
          font-size: 18px;
        }

        .yearlyName {
          // font-weight: lighter;
        }

        .planYearlyCost {
          font-size: 20px;
          font-weight: bold;
        }

        .planYearly {
          font-size: 20px;
          margin-top: 5px;
          height: 15px;
        }

        .buttonWrapper {
          margin-top: 40px;
          width: 100%;

          .buttonBuy {
            font-size: 20px;
            background-color: white;
            color: @pipl-blue;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            padding-top: 10px;
            padding-bottom: 10px;
            border: @pipl-blue solid 0.5px;
            // padding: 20px;
            // width: 90px;

            &:hover {
              background-color: @pipl-blue;

              color: white;
              scale: 1.2;
            }
          }
        }

        &:hover {
          border: @pipl-blue solid 0.5px;
          box-shadow: 1px 3px 3px 0px rgba(0, 0, 0, 0.1);
          .buttonBuy {
            background-color: @pipl-blue;
            color: white;
          }
        }
      }
    }
  }

  .plansDetails {
    margin-top: 50px;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-weight: lighter;
      font-size: 32px;
      margin: auto;
    }

    .details {
      margin-top: 30px;
    }

    .detialsIcon {
      margin-right: 10px;
    }

    .detailsLineWrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px;
    }

    .detailsRow {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 20px;
      grid-row-gap: 10px;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .detailsCol {
      // min-width: 300px;
      // padding-left: 40px;
    }

    .detailsText {
      font-size: 22px;
      font-weight: lighter;
    }
  }
}

@media screen and (max-width: @screen-sm-max) {
  .pricingFrame_container {
    .title {
      font-size: 22px;
    }

    .plansDetails {
      .detailsRow {
        grid-template-columns: 1fr;
      }
    }

    .pricingBox {
      .upperRow {
        .header {
          font-size: 18px;
        }

        .yearlyText {
          .smallText {
            font-size: 14px;
          }
        }
      }
      .plansContainer {
        .planBox {
          .planCost {
            margin-top: 10px;
          }

          .planBody {
            margin-top: 20px;
            font-size: 13px;
            height: 50px;
          }

          .planTitle {
            font-size: 15px;
          }

          .monthlyCost {
            font-size: 15px;
          }

          .monthlyName {
            font-size: 13px;
          }

          .yearlyName {
            font-size: 13px;
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/MarketingPage/components/PricingFrame.less